/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

import { connect } from 'react-redux'

import { ThunkDispatch, ReduxState } from '@/types/redux'

import { deleteOrganizationInvitations } from '../../../../actions/organizations'
import { deleteOrganizationInvitationsRequest } from '../../../../reducers/asyncRequests/registry'

import RevokeInvitationModal from './RevokeInvitationModal'

import type { StateProps, DispatchProps, ConsumerProps } from './types'

const mapStateToProps = (
  state: ReduxState,
  {
    organization: { id: organizationId },
    organizationMemberRow: { id: invitationToken },
  }: ConsumerProps,
): StateProps => ({
  deleteOrganizationInvitationRequest: () =>
    deleteOrganizationInvitationsRequest(state, organizationId, invitationToken),
})

const mapDispatchToProps = (
  dispatch: ThunkDispatch,
  {
    organization: { id: organizationId },
    organizationMemberRow: { id: invitationToken },
  }: ConsumerProps,
): DispatchProps => ({
  deleteOrganizationInvitation: () =>
    dispatch(deleteOrganizationInvitations({ organizationId, tokens: [invitationToken] })),
})

export default connect<StateProps, DispatchProps, ConsumerProps>(
  mapStateToProps,
  mapDispatchToProps,
)(RevokeInvitationModal)
